import React, { useState, useEffect, useCallback } from 'react';
import { getPaymentHistories } from '../services/api';

const PaymentHistoryPage = () => {
    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchHistory = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const response = await getPaymentHistories();
            setHistories(response.data.data?.items || []);
        } catch (err) {
            setError('無法獲取付款紀錄，請稍後再試。');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    const formatItemName = (item) => {
        if (item.itemName === 'subscription') {
            return `訂閱方案: ${item.detail}`;
        }
        if (item.itemName === 'mkpu_purchase') {
            return `點數購買: ${item.detail}`;
        }
        return item.itemName;
    };

    if (loading) return <div className="page-container">正在載入付款紀錄...</div>;
    if (error) return <p className="error-message">{error}</p>;

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>付款紀錄</h2>
                <button onClick={fetchHistory} disabled={loading} className="refresh-button">
                    {loading ? '刷新中...' : '重新整理'}
                </button>
            </div>

            <div className="table-container">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>建立時間</th>
                            <th>項目</th>
                            <th>數量</th>
                            <th>金額</th>
                            <th>付款狀態</th>
                            <th>發票狀態</th>
                        </tr>
                    </thead>
                    <tbody>
                        {histories.length > 0 ? (
                            histories.map((item, index) => (
                                <tr key={item.invoiceNo || index}>
                                    <td>{new Date(item.createdAt).toLocaleString()}</td>
                                    <td>{formatItemName(item)}</td>
                                    <td>{item.quantity}</td>
                                    <td>{item.currency} ${item.amount.toLocaleString()}</td>
                                    <td><span className={`status-badge status-${item.paymentStatus}`}>{item.paymentStatus}</span></td>
                                    <td><span className={`status-badge status-${item.invoiceStatus}`}>{item.invoiceStatus}</span></td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">沒有任何付款紀錄。</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PaymentHistoryPage;